import React, { FC } from "react";
import {
  CategorizationSetType,
  CategorizationWithConfig,
} from "../../../../configMap/interfaces/category";
import FixedCategorizationCellWrapper from "./FixedCategorizationCellWrapper";
import DynamicCategorizationCellWrapper from "./DynamicCategorizationCellWrapper";

type Props = {
  disabled: boolean;
  categorizationWithConfig: CategorizationWithConfig;
  index: number;
  groupBlockId?: string;
};

const CategorizationCellSwitch: FC<Props> = (props) => {
  const { categorizationWithConfig } = props;
  const { setType } = categorizationWithConfig.categorization;

  switch (setType) {
    case CategorizationSetType.FIXED:
      return <FixedCategorizationCellWrapper {...props} />;
    default:
      return <DynamicCategorizationCellWrapper {...props} />;
  }
};

export default CategorizationCellSwitch;
